import React, { useState } from "react";
import {
  Dimensions,
  FlatList,
  Image,
  Modal,
  Pressable,
  SafeAreaView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from "react-native";

// import { useTranslation } from "react-i18next";
import AppImages from "../../../Constants/AppImages";
import AppColors from "../../../Constants/AppColors";
import AppFonts from "../../../Constants/AppFonts";
import { PaidLIst, VehicleSync } from "../../../Constants/Data";
import Appstyles from "../../../Constants/AppStyles";

const { width, height } = Dimensions.get("window");
// const Tab = createMaterialTopTabNavigator()

const Paid = ({ navigation }) => {
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };
  const [DotModal, setDotModal] = useState(false);
  const [select, setSelected] = useState(1);
  //   const [Modalvisible1, setModalvisible1] = useState(false)
  //----------------
  const [selectedButtonIndex, setSelectedButtonIndex] = useState(0);

  const handleButtonPress = (index) => {
    setSelectedButtonIndex(!index);
  };
  //----------------
  const [selectedButton, setSelectedButton] = useState(1);

  const handleBoxPressbtn = (item) => {
    setSelectedButton(item);
  };
  const handlePress = () => {
    setSelected(!select);
  };
  // placeholder="Search Car..."
  return (
    <SafeAreaView style={Appstyles.safe7}>
      {selectedButtonIndex === 0 ? (
        <View style={Appstyles.SecMainPaid7}>
          <View style={Appstyles.AsddwPaid7}>
            <View style={Appstyles.Anno7}>
              <View style={Appstyles.Searchvi6}>
                <TextInput
                  style={Appstyles.TextInput7}
                  placeholder="Search Invoice Number,Date, Amount...."
                  placeholderTextColor={"#AAAAAA"}
                  editable={true}
                  // value={searchText}

                  autoCapitalize="none"
                  // onChangeText={(text) => setsearchText(text)}
                />

                <View style={Appstyles.SearchImageView}>
                  <Image
                    source={AppImages.search}
                    style={Appstyles.SearchImage}
                  />
                </View>
              </View>

              <Image
                source={AppImages.Import}
                style={Appstyles.ImpoShare7}
                resizeMode="contain"
              />

              <Image
                source={AppImages.Shareit}
                style={Appstyles.ImpoShare7}
                resizeMode="contain"
              />
            </View>
          </View>
          <FlatList
            showsVerticalScrollIndicator={false}
            ListFooterComponent={() => <View style={{ padding: 50 }} />}
            data={PaidLIst}
            renderItem={({ item }) => (
              <View style={{}}>
                <View style={Appstyles.FlatmainPaid7}>
                  <View style={Appstyles.FlatmainSecPaid7}>
                    <View style={Appstyles.FlatImgPaid7}>
                      <View style={Appstyles.flexDirection}>
                        <Image
                          source={item.img}
                          style={Appstyles.paisd7}
                          resizeMode="contain"
                        />
                        <View style={Appstyles.FlatTxtff7}>
                          <Text style={Appstyles.FlatTxtSeccD7}>
                            {t("common:translation.Invoice Number")}
                          </Text>
                          <Text style={Appstyles.CopyTextSeefer7}>
                            {item.Date}
                          </Text>
                        </View>
                      </View>
                      <TouchableOpacity onPress={() => setDotModal(true)}>
                        <Image
                          source={item.Dot}
                          style={Appstyles.iamgerr7}
                          resizeMode="contain"
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                  <View>
                    <View style={Appstyles.lineeedss7}></View>
                  </View>

                  <View style={Appstyles.fullygf7}>
                    <View style={Appstyles.flexDirection}>
                      <Text style={Appstyles.Texttsdasd7}>
                        Payment Type
                        {/* {t('common:translation.Sync Request Date')} */}
                      </Text>
                      <Text style={Appstyles.TextTwoss7}>
                        {/* {t('common:translation.Sync Request Date')} */}
                        Payment Mode
                      </Text>
                    </View>
                    <View style={Appstyles.flexDirection}>
                      <Text style={Appstyles.CopyTextSecPaid7}>
                        {item.Services}
                      </Text>
                      <Text style={styles.CopyText}>{item.Cash}</Text>
                    </View>
                    <View style={Appstyles.flexDirection}>
                      <Text style={Appstyles.Texttsdasd7}>
                        {/* {t('common:translation.Sync Period')}
                         */}
                        Payment Identification Number
                      </Text>
                      <Text style={Appstyles.TextTwoss7}>
                        Amount
                        {/* {t('common:translation.Sync Request Status')} */}
                      </Text>
                    </View>

                    <View style={Appstyles.flexDirection}>
                      <Text style={Appstyles.CopyTextSec17}>{item[668]}</Text>
                      <Text style={Appstyles.CopyText1paid7}>{item.$1200}</Text>
                    </View>
                    <View style={Appstyles.flexDirection}>
                      <Text style={Appstyles.Texttsdasd7}>
                        Payment Date
                        {/* {t('common:translation.Sync Start Date')} */}
                      </Text>
                      <Text style={Appstyles.NonCopyPaid7}>
                        Invoice Date
                        {/* {t('common:translation.Sync End Date')} */}
                      </Text>
                    </View>
                    <View style={Appstyles.flexDirection}>
                      <Text style={Appstyles.CopyTextSecPaid7}>{item.T2}</Text>
                      <Text style={Appstyles.CopyTextSecPaid7}>{item.T2}</Text>
                    </View>
                  </View>
                </View>
              </View>
            )}
          />
        </View>
      ) : (
        <View style={{ flex: 1 }}></View>
      )}

      <Modal
        animationType="slide"
        visible={DotModal}
        onRequestClose={() => {
          setDotModal(!DotModal);
        }}
        transparent={true}
      >
        <Pressable
          style={Appstyles.pressePaidModal}
          onPress={() => setDotModal(false)}
        >
          <View style={Appstyles.viwwPaidiiii7}>
            <TouchableOpacity style={Appstyles.hshppaidg7}>
              <Image source={AppImages.LineBar} style={Appstyles.jnspaocp7} />
            </TouchableOpacity>

            <TouchableOpacity
              style={Appstyles.fffsfsadsPaid}
              onPress={() => [
                setDotModal(false),
                navigation.navigate("PaymentReceipt"),
              ]}
            >
              <View style={Appstyles.yooosdpaid7}>
                <Text style={Appstyles.ttxtpoibvpaid7}>Receipt</Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              style={Appstyles.fffsfsadsPaid}
              onPress={() => [
                setDotModal(false),
                navigation.navigate("PaymentReceiptInvoice"),
              ]}
            >
              <View style={Appstyles.yooosdpaid7}>
                <Text style={Appstyles.modowed7}>Invoice</Text>
              </View>
            </TouchableOpacity>
          </View>
        </Pressable>
      </Modal>
      {/* //-----------DeleteModal------// */}

      {/* <Modal
        animationType="slide"
        transparent={true}
        visible={Modalvisible1}
        onRequestClose={() => {
          setModalvisible1(!Modalvisible1)
        }}
      >
        <Pressable
          onPress={() => setModalvisible1(false)}
          style={styles.presse}
        >
          <View style={styles.dsdd}>
            <View style={styles.sss}>
              <View style={styles.fd}>
                <View style={{}}>
                  <Text style={styles.hbh}>
                    {t('common:translation.Delete Vehicle')}
                  </Text>
                </View>
              </View>
              <TouchableOpacity
                onPress={() => {
                  setModalvisible1(false)
                }}
              >
                <Image
                  source={AppImages.cross}
                  style={styles.hhsj}
                  resizeMode="contain"
                />
              </TouchableOpacity>
            </View>

            <View style={styles.lins}></View>
            <View style={styles.fasfd}>
              <Text style={styles.sdsds}>
                {t(
                  'common:translation.Delete Vehicle Are you sure you want to delete this Vehicle ?',
                )}
              </Text>
            </View>

            <View style={styles.mmm}>
              <View style={styles.hox}>
                {ModalDel.map((item, index) => (
                  <View
                    onPress={() => handleBoxPressbtn(item)}
                    style={styles.presss}
                  >
                    {selectedButton === index ? (
                      <TouchableOpacity
                        onPress={() => [
                          // handleBoxPressbtn(item),
                          setModalvisible1(false),
                        ]}
                      >
                        <View style={{}}>
                          <View
                            style={[
                              styles.LoginWithOtpVw,
                              {
                                backgroundColor:
                                  selectedButton === index
                                    ? AppColors.brown
                                    : AppColors.C4900C,
                              },
                            ]}
                          >
                            <Text
                              style={[
                                styles.RegisterTxt,
                                {
                                  color:
                                    selectedButton === index
                                      ? AppColors.white
                                      : AppColors.C4900CC,
                                },
                              ]}
                            >
                              {item.label}
                            </Text>
                          </View>
                        </View>
                      </TouchableOpacity>
                    ) : (
                      <TouchableOpacity
                        onPress={() => [
                          // handleBoxPressbtn(item),
                          setModalvisible1(false),
                        ]}
                      >
                        <View style={{}}>
                          <View style={{}}>
                            <View
                              style={[
                                styles.LoginWithOtpVw,
                                {
                                  backgroundColor:
                                    selectedButton === index
                                      ? AppColors.brown
                                      : AppColors.C4900C,
                                },
                              ]}
                            >
                              <Text
                                style={[
                                  styles.RegisterTxt,
                                  {
                                    color:
                                      selectedButton === index
                                        ? AppColors.white
                                        : AppColors.C4900CC,
                                  },
                                ]}
                              >
                                {item.label}
                              </Text>
                            </View>
                          </View>
                        </View>
                      </TouchableOpacity>
                    )}
                  </View>
                ))}
              </View>
            </View>
          </View>
        </Pressable>
      </Modal> */}
    </SafeAreaView>
  );
};

export default Paid;
const styles = StyleSheet.create({
  MainView: { backgroundColor: AppColors.white, flex: 1 },
  SecMain: { marginHorizontal: 20, backgroundColor: AppColors.white },
  TExtinputView: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",

    marginTop: 10,
    width: "100%",
    paddingVertical: 10,
    // height: height * 0.04,
  },
  TExtinput: {
    fontSize: 12,
    alignItems: "center",
    fontFamily: AppFonts.OverpassMedium,
    width: "80%",
    borderRadius: 10,
    borderColor: AppColors.sandal,
    // height: height * 0.05,
    borderWidth: 1,
    paddingLeft: 20,
    flexDirection: "row",

    borderRadius: 8,
    justifyContent: "space-between",

    shadowColor: "#000001A",
    shadowOffset: { width: 1, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 1,
    // elevation: 6,
  },
  ExImport: { flexDirection: "row", marginHorizontal: 10 },
  Flatmain: {
    marginBottom: 20,
    backgroundColor: "#F6EFE9",
    borderRadius: 10,
  },
  FlatmainSec: {
    marginLeft: 10,
    paddingVertical: 10,
    paddingHorizontal: 10,
  },
  FlatImg: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  FlatTxt: { justifyContent: "center", marginLeft: 20 },
  FlatTxtSec: {
    // marginTop: 5,
    fontSize: 12,

    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.dualbrown,
  },
  tabe: { width: 155 },
  FlatTxtT2: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },

  CopyText: {
    fontSize: 14,
    marginTop: 2,

    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  CopyTextSec: {
    width: "50%",
    fontSize: 14,
    marginTop: 2,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  CopyTextSe: {
    fontSize: 14,
    marginTop: 3,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  NonCopy: {
    width: width * 0.4,
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },
  Row: { flexDirection: "row" },

  Textt: {
    width: "50%",
    marginTop: 10,
    fontSize: 12,

    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },

  TextTwo: {
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },
  //--------modal Del
  hox: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginVertical: 20,
  },
  presss: {
    width: "40%",
    marginHorizontal: 10,
  },
  //-------cancel  btn---//
  sty: {
    flexDirection: "row",
    marginVertical: 10,
  },
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    height: 35,
    width: "100%",
  },
  RegisterTxt: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    // color: AppColors.white,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpV: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "100%",
    height: 40,
  },
  lins: {
    borderTopWidth: 1,
    width: "100%",
    // right: 20,
    borderTopColor: AppColors.sandal,
    marginTop: 20,
  },
  vee: {
    alignItems: "flex-end",
    justifyContent: "center",
    flex: 1,
  },
  im: { width: 20, height: 20, marginRight: 30 },
  too: { alignSelf: "flex-end", justifyContent: "center" },
  ims: { width: 22, height: 22 },
  ha: { width: 22, height: 22, marginLeft: 10 },
  iamge: { width: 22, height: 22, alignItems: "center" },
  feed: { backgroundColor: AppColors.FeedBack, flex: 1, opacity: 0.55 },
  viww: {
    width: "100%",
    backgroundColor: "white",

    borderTopRightRadius: 16,
    borderTopLeftRadius: 16,
    position: "absolute",
    bottom: 0,
    padding: 20,
  },
  hsh: { justifyContent: "center", alignItems: "center" },
  jns: { width: "15%", height: 2 },
  yooo: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
  },
  ttxt: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 14,
    color: AppColors.dualbrown,
  },
  fffsf: {
    marginTop: 20,
    flexDirection: "row",
  },
  modo: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 16,
    color: AppColors.brown1,
  },
  presse: {
    flex: 1,
    backgroundColor: AppColors.ModalColor,
    alignItems: "center",
    justifyContent: "center",
  },
  dsdd: {
    backgroundColor: "white",
    borderRadius: 20,
    marginHorizontal: 20,
    width: "80%",
    paddingTop: 15,
  },
  sss: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginHorizontal: 20,
  },
  fd: { flexDirection: "row", alignItems: "center" },
  hbh: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 20,
    lineheight: 25.32,
    color: AppColors.brown1,
  },
  hhsj: { width: 12, height: 12, alignItems: "center" },
  fasfd: { marginTop: 20, marginHorizontal: 20 },
  sdsds: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    lineheight: 17.72,
    color: AppColors.brown1,
  },
  Row1: {
    flexDirection: "row",
  },
  CopyText1: {
    fontSize: 14,
    marginTop: 2,

    alignItems: "center",
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  CopyTextSec1: {
    width: "50%",
    fontSize: 14,
    marginTop: 2,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
    alignItems: "center",
  },
  mmm: {
    flexDirection: "row",
    alignSelf: "flex-end",

    marginHorizontal: 20,
  },
  toda: { marginTop: 20, flexDirection: "row" },
  Searchstyle: {
    flex: 1,
    backgroundColor: "white",
    width: "100%",
    // marginTop: 20

    // flexGrow: 30,
  },
  tab: { backgroundColor: AppColors.brown },
});
